import { z } from 'zod'
import type { ApiClient } from '../apiClient'

export const chartRegistryRowSchema = z.object({
  page: z.string(),
  kpi: z.string(),
  chart_slot: z.string(),
  walk_function: z.string(),
  default_params: z.record(z.unknown()),
  display_order: z.number().int(),
  chart_type: z.string(),
  default_facet: z
    .string()
    .nullish()
    .transform((v) => v ?? null),
  title: z.string().nullable(),
  description: z.string().nullable(),
  enabled: z.boolean(),
  required_role: z.enum(['app', 'app_admin']),
})
export type ChartRegistryRow = z.infer<typeof chartRegistryRowSchema>

export async function getCharts(
  client: ApiClient,
  page: string,
  kpi: string,
  signal?: AbortSignal,
): Promise<ChartRegistryRow[]> {
  const raw = await client.rpc<unknown>('get_charts', { p_page: page, p_kpi: kpi }, { signal })
  return z.array(chartRegistryRowSchema).parse(raw)
}
